__turbopack_context__.v({
  "actions": "tabs-module__Z-VKrG__actions",
  "container": "tabs-module__Z-VKrG__container",
  "form": "tabs-module__Z-VKrG__form",
  "noPractice": "tabs-module__Z-VKrG__noPractice",
  "practiceCity": "tabs-module__Z-VKrG__practiceCity",
  "practiceDetail": "tabs-module__Z-VKrG__practiceDetail",
  "practiceInfo": "tabs-module__Z-VKrG__practiceInfo",
  "practiceInfoHint": "tabs-module__Z-VKrG__practiceInfoHint",
  "practiceName": "tabs-module__Z-VKrG__practiceName",
  "practiceSection": "tabs-module__Z-VKrG__practiceSection",
  "practiceSectionHeader": "tabs-module__Z-VKrG__practiceSectionHeader",
  "practiceSectionTitle": "tabs-module__Z-VKrG__practiceSectionTitle",
  "resetSection": "tabs-module__Z-VKrG__resetSection",
  "row": "tabs-module__Z-VKrG__row",
  "separator": "tabs-module__Z-VKrG__separator",
});
